import React from 'react';
import Datapoint from "./Datapoint";

import ParalelDatapoint from './ParalelDatapoint';

import styles from './Timeline.module.scss';


const Timeline = ({data, horizontal}) => {
    return <div className={horizontal && styles.horizontal}>
        {data.map((point, index) => {
            if (point.paralel) {
                return <ParalelDatapoint key={point.title} point={point} mergeEnd={!data[index + 1]?.paralel} />;
            }

            return (
                <Datapoint
                    title={point.title}
                    description={point.description}
                    image={point.image}
                    imageWidth={point.imageWidth}
                    video={point.video}
                    position={!horizontal && index % 2 === 0 ? 'left' : 'right'}
                    direction={horizontal ? 'horizontal' : 'vertical'}
                />
            );
        })}
    </div>;
}

export default Timeline;